import styled from 'styled-components';
import { popoverShadow } from '../../themes/shadows';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid grey;
  border-radius: 10px;
  width: 100px;
  position: relative;
  cursor: pointer;
  label {
    margin-left: auto;
    font-size: 10px;
    font-weight: bold;
    color: ${(props) => props.theme.colors.label};
    cursor: inherit;
  }
`;

export const ArrowDown = styled.div`
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  margin: 0 5px 0 auto;
  border-top: 4px solid ${(props) => props.theme.colors.label};
`;

export const ListWrapper = styled.ul`
  position: absolute;
  top: 20px;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors.lightergrey};
  border-radius: 6px;
  width: 100px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 2;
  box-shadow: ${popoverShadow};
  option {
    padding: 4px 0;
    font-size: 14px;
    :hover {
      background: ${(props) => props.theme.colors.white};
    }
  }
`;

export const InputFilter = styled.input`
  width: 100%;
  min-height: 40px;
  margin-bottom: 5px;
  background: ${(props) => props.theme.colors.lightgrey};
  text-align: center;
`;
